interface AssetClassChart {
  name: string;
  y: number;
  color_group: number;
  color: number;
}

interface Item {
  Id: number;
  GroupId: number;
  PortfolioName: string;
  PortfolioDescription: string;
  HighLevelChart: AssetClassChart[];
  DetailedAssetAllocation: AssetClassChart[];
}

interface Group {
  GroupId: number;
  GroupName: string;
  ModelPortfolios: Item[];
}

interface ModelPortfolios {
  ModelPortfolios: {
    Id: number;
    GroupId: number;
    Name: string;
    PortfolioDescription: string;
    AssetClassChart: AssetClassChart[];
  }[];
  DetailedModelPortfolios: {
    Id: number;
    GroupId: number;
    Name: string;
    PortfolioDescription: string;
    AssetClassChart: AssetClassChart[];
  }[];
}

export const getSimpleAndDetailedModelPortfolios = (modelPortfolio: Item) => {
  const {
    PortfolioName: Name,
    HighLevelChart,
    DetailedAssetAllocation,
    ...ModelPortfoliosInfo
  } = modelPortfolio;

  return {
    simple: {
      ...ModelPortfoliosInfo,
      Name,
      AssetClassChart: HighLevelChart,
    },
    detailed: {
      ...ModelPortfoliosInfo,
      Name,
      AssetClassChart: DetailedAssetAllocation,
    },
  };
};

export const normalizeModelPortfolios = (
  normalizedModelPortfolios: ModelPortfolios,
  modelPortfolioGroup: Group,
) => {
  const { ModelPortfolios } = modelPortfolioGroup;

  const simpleAndDetailedModelPortfolios = ModelPortfolios.map(getSimpleAndDetailedModelPortfolios);

  const simple = simpleAndDetailedModelPortfolios.map(({ simple }) => simple);
  const detailed = simpleAndDetailedModelPortfolios.map(({ detailed }) => detailed);

  return {
    ...normalizedModelPortfolios,
    ModelPortfolios: [...normalizedModelPortfolios.ModelPortfolios, ...simple],
    DetailedModelPortfolios: [...normalizedModelPortfolios.DetailedModelPortfolios, ...detailed],
  };
};

export const getModelPortfolios = (modelPortfolios: Group[]) => {
  return modelPortfolios.reduce(normalizeModelPortfolios, {
    ModelPortfolios: [],
    DetailedModelPortfolios: [],
  });
};

export const getModelPortfoliosGroups = (modelPortfolios: Group[]) => {
  return modelPortfolios.map(modelPortfolio => ({
    groupId: modelPortfolio.GroupId || 'default',
    title: modelPortfolio.GroupName,
  }));
};
